import { FC } from "react";

import {
  VnAlertDialog,
  VnAlertDialogAction,
  VnAlertDialogCancel,
  VnAlertDialogContent,
  VnAlertDialogDescription,
  VnAlertDialogFooter,
  VnAlertDialogHeader,
  VnAlertDialogTitle,
} from "@/components/VnAlertDialog";
import { getApplicantFirstNames } from "@/domain/applicationApplicants";
import { RecentDuplicateApplicationType } from "@/domain/applications";
import { formatMemberList, getProgramTypeLabel } from "@/utils/brandLabel";

type RecentDuplicateApplicationsDialogPropsType = {
  applications: RecentDuplicateApplicationType[];
  onClose: () => void;
  onContinue: () => void;
};

export const RecentDuplicateApplicationsDialog: FC<
  RecentDuplicateApplicationsDialogPropsType
> = ({ applications, onClose, onContinue }) => {
  const recentDuplicateApplication = applications[0];
  const hasMultipleApplicationTypes = applications.length > 1;
  const applicationTypes = formatMemberList({
    names: applications.map(application =>
      getProgramTypeLabel(application.applicationType),
    ),
  });
  const applicantFirstNames = formatMemberList({
    names: getApplicantFirstNames(
      applications.flatMap(application => application.applicants),
    ),
  });

  return (
    <VnAlertDialog
      open={applications.length > 0}
      onOpenChange={isOpen => {
        if (!isOpen) onClose();
      }}>
      <VnAlertDialogContent>
        <VnAlertDialogHeader>
          <VnAlertDialogTitle i18nKey="native:applicationForm.recentDuplicateDialog.title" />
          <VnAlertDialogDescription
            i18nKey={
              hasMultipleApplicationTypes
                ? "native:applicationForm.recentDuplicateDialog.multipleDescription"
                : "native:applicationForm.recentDuplicateDialog.description"
            }
            i18nOptions={{
              applicationType: recentDuplicateApplication
                ? getProgramTypeLabel(
                    recentDuplicateApplication.applicationType,
                  )
                : "",
              applicationTypes,
              memberNames: applicantFirstNames,
            }}
          />
        </VnAlertDialogHeader>
        <VnAlertDialogFooter>
          <VnAlertDialogCancel variant="default" i18nKey="common:back" />
          <VnAlertDialogAction
            variant="outline"
            i18nKey="native:applicationForm.recentDuplicateDialog.continueAnyway"
            onPress={onContinue}
          />
        </VnAlertDialogFooter>
      </VnAlertDialogContent>
    </VnAlertDialog>
  );
};
